<template>
  <div
    class="Login full-height"
    style="min-width:368px"
  >
    <van-button type="default" icon="arrow-left" round size="small" class="kh-back" @click="$router.push({ path: '/home' })"/>
    <ld-statusbar bg-white />
    <div style="height: 100%;width: 100%;">
      <div class="title">
        <div class="to1">
          <!--<img :src="loginConfig.logoUrl">-->
          <img src="../../images/home/logon01.png">
        </div>
        <div class="to2">
          <img src="../../images/home/bj1.png">
        </div>
        <!--    登录部分-->
        <div class="kh-login">
          <van-tabs
            @click="onClick"
            color="#706BEB"
          >
            <van-tab title="用户名密码登录" />
            <van-tab title="短信验证码登录" />
          </van-tabs>
          <!-- 手机号框 -->
          <div class="login-input">
            <van-field
              v-if="loginType === 1"
              v-model="telphone"
              size="15"
              placeholder="请输入登录账号"
            />
            <!--            right-icon="contact"-->
            <van-field
              v-else
              type="number"
              v-model="telphone"
              :placeholder="$t('G040','请输入手机号码')"
            />
            
            <i class="van-icon van-icon-contact kh-phone-log"/>
          </div>
          <!-- 密码框 -->
          <div class="login-input">
            <van-row
              v-if="this.loginType ==1"
              type="flex"
            >
              <van-col
                span="18"
                style="width: 100%;display: flex;"
              >
                <van-field
                  style="width: 100%"
                  :type="(loginType === 1 && !passwordShow) ? 'password' : 'text'"
                  v-model="password"
                  class="text-space"
                  :maxlength="loginType === 1 ? undefined : 6"
                  :placeholder="loginType === 1 ? $t('G028','请输入密码') : $t('G235','请输入验证码')"
                  @change="function(){}"
                  @focus="function(){}"
                  @blur="function(){}"
                  autocomplete="off"
                />
                <div
                  v-if="loginType === 1"
                >
                
                  <!-- class="text-right" -->
                  <ld-icon
                    v-if="passwordShow"
                    @click="passwordShow = false"
                    class="gray valid-password van-hairline--right kh-phone-log2"
                    type="icon-yanjing_xianshi_o"
                  />
                  <ld-icon
                    v-else
                    @click="passwordShow = true"
                    class="gray valid-password van-hairline--right kh-phone-log2"
                    type="icon-yanjing_yincang_o"
                  />
                </div>
              </van-col>
            </van-row>
            <van-row
              v-if="this.loginType ==2"
              type="flex"
            >
              <van-col
                span="18"
                class="kh-yzm"
              >
                <van-field
                  style="width: 70%"
                  :type="(loginType === 1 && !passwordShow) ? 'password' : 'text'"
                  v-model="password"
                  class="text-space"
                  :maxlength="loginType === 1 ? undefined : 6"
                  :placeholder="loginType === 1 ? $t('G028','请输入密码') : $t('G235','请输入验证码')"
                  @change="function(){}"
                  @focus="function(){}"
                  @blur="function(){}"
                  autocomplete="off"
                />
                <div>
                  <van-button
                    style="width: 93px;margin: 0px 0px 0px 10px; position: relative;left: -14px;"
                    class="kh-log"
                    v-if="loginType === 2"
                    @click="getSmsValidCode()"
                    color="#706dec"
                  >
                    {{ smsCodeTips }}
                  </van-button>
                </div>
                <div
                  v-if="loginType === 1"
                  class="text-right"
                >
                  <ld-icon
                    v-if="passwordShow"
                    @click="passwordShow = false"
                    class="gray valid-password van-hairline--right kh-log1"
                    type="icon-yanjing_xianshi_o"
                  />
                  <ld-icon
                    v-else
                    @click="passwordShow = true"
                    class="gray valid-password van-hairline--right kh-log1"
                    type="icon-yanjing_yincang_o"
                  />
                </div>
              </van-col>
            </van-row>
            <van-col
              span="6"
              style="margin-left: 76%;height: 20px"
            >
              <router-link
                style="color: #7F7F7F;font-size: 12px"
                to="/resetPassword"
                v-if="this.loginType ==1"
              >
                忘记密码
              </router-link>
              <router-link
                style="color: #7F7F7F;"
                to="/resetPassword"
                v-if="this.loginType ==2"
              />
            </van-col>
          </div>
          <!-- 验证码 -->
          <van-row
            type="flex"
            align="center"
            class="login-input"
            v-if="loginType === 1 && failCount >= failCountThreshold"
          >
            <van-col span="18">
              <van-field
                class="font18"
                type="text"
                v-model="validCode"
                maxlength="6"
                placeholder="请输入校验码"
                autocomplete="off"
                @input="changeValidCode"
              />
            </van-col>
            <van-col span="6">
              <img
                :src="validCodeImgSrc"
                @click="getImgValidCode()"
                class="valid-img"
              >
            </van-col>
          </van-row>
          <!-- 登录按钮 -->
          <ld-button
            @click.native="getCorp"
            class="login_btn"
            :disabled="(checkedLicense&&telphone&&password)==false"
            size="lg"
            style="color: #fff;font-size: 15px;"
          >
            登录
          </ld-button>
          <!-- 协议 -->
          <div class="license">
            <van-checkbox
              checked-color="#764EE4"
              v-model="checkedLicense"
            >
              阅读并同意我们的<span
                class="khmain-color"
                @click.stop="showLicense=true"
              >《服务协议》
              </span>与<span
                class="khmain-color"
                @click.stop="showLicense2=true"
              >《隐私条款》
              </span>
            </van-checkbox>
          </div>



          <van-row class="forget" v-if="false">
            <van-col span="12">
              <a
                v-if="loginType === 2"
                class="fl main-color"
                @click="changeLoginType(1)"
              >
                密码登录
              </a>
              <a
                v-if="loginType === 1"
                class="fl main-color"
                @click="changeLoginType(2)"
              >
                短信验证码登录
              </a>
            </van-col>
            <van-col
              span="12"
              class="text-right"
            >
              <router-link
                class="main-color"
                to="/register"
              >
                注册
              </router-link>
            </van-col>
          </van-row>

          <!-- 服务协议详情 -->
          <van-popup
            v-model="showLicense"
            position="right"
            :close-on-popstate="true"
            class="full-height full-width"
          >
            <ld-header @click-left="showLicense = false">
              《{{ loginConfig.pageName }}服务协议》
            </ld-header>
            <div class="font14 showLicense">
              <mescroll-vue
                ref="mescroll"
                :down="{ use: false }"
              >
                <div v-if="loginConfig.by5">
                  <pre
                    v-html="loginConfig.by5"
                    class="pad8 pre-wrap"
                  />
                </div>
              </mescroll-vue>
            </div>
          </van-popup>
          <!-- 隐私条款详情 -->
          <van-popup
            v-model="showLicense2"
            position="right"
            :close-on-popstate="true"
            class="full-height full-width"
          >
            <ld-header @click-left="showLicense2 = false">
              《{{ loginConfig.pageName }}隐私条款》
            </ld-header>
            <div class="font14 showLicense2">
              <mescroll-vue
                ref="mescroll"
                :down="{ use: false }"
              >
                <div v-if="loginConfig.by2">
                  <pre
                    v-html="loginConfig.by2"
                    class="pad8 pre-wrap"
                  />
                </div>
              </mescroll-vue>
            </div>
          </van-popup>

          <van-dialog
            v-model="showXy"
            title="请阅读《服务协议》和《隐私条款》"
            show-cancel-button
            cancel-button-text="不同意"
            confirm-button-text="同意"
            @confirm="agree"
          >
            <div class="font14 gray box">
              <div class="indent">
                依据最新法律要求，我们更新了
                <span
                  class="main-color"
                  @click.stop="showLicense=true"
                >《服务协议》</span>和
                <span
                  class="main-color"
                  @click.stop="showLicense2=true"
                >《隐私条款》</span>，请您务必审慎阅读、充分理解相关条款内容，并确定了解我们对您个人信息的处理规则。
              </div>
              <div class="indent">
                点击同意即代表您已阅读并理解以上政策，您可立即开始使用我们的产品和服务；如果您点击不同意，将无法使用我们提供的服务。
              </div>
              <div class="indent">
                我们将尽全力保护您的个人信息和合法权益，再次感谢您对本产品的信任！
                （点击<span
                  class="main-color"
                  @click.stop="showLicense=true"
                >《服务协议》</span>和
                <span
                  class="main-color"
                  @click.stop="showLicense2=true"
                >《隐私条款》</span>，打开服务协议和隐私条款内容页面）
              </div>
            </div>
          </van-dialog>

          <!-- 获取验证码  -->
          <choose-corp
            ref="corp"
            :btn-text="(loginType==1||(loginType==2&&hasCompId==false))?'登录':'获取验证码'"
            :comp-list="compList"
            @selected="corpChecked"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Field, Popup, Checkbox ,Dialog,RadioGroup, Radio,CellGroup,Cell,Tab, Tabs,Button } from 'vant'

import { API_DEFAULT_CONFIG } from 'Config'
import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'
import { validators } from 'Utils/valid'
// import { update } from 'CommonUtils/updateApp.js'
import { isH5,getDeviceInfo } from 'CommonUtils/plus.js'
import { localget, localset } from 'Utils/storage.js'
import chooseCorp from 'Views/User/Login/chooseCorp/index.vue'

import { standardSSO } from 'Utils/ssoLogin'
import { parseQueryString } from 'Utils/string'
import ldStatusbar from 'Common/ldStatusbar'


export default {
  components: {
    ldButton,
    [Field.name]:Field,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [CellGroup.name]:CellGroup,
    [Cell.name]:Cell,
    [Checkbox.name]:Checkbox,
    [Popup.name]:Popup,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Dialog.name]:Dialog,
    [Button .name]:Button ,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    chooseCorp,
    ldStatusbar
  },
  data () {
    return {
      active: 2,
      telphone: '',
      showLicense:false,
      showLicense2:false,
      passwordShow: false,
      password: '',
      corpList: [], // 企业列表
      compList:[],
      loginType: 1, // 1工号/手机号登录；2手机+验证码登录
      failCount: 0, // 登录失败次数
      failCountThreshold: 3, // 登录失败次数阈值
      validCode: '',
      validateCodeId: '', // 获取校验码的时间戳
      validCodeImgSrc: '',
      smsCodeTips: '获取验证码',
      checkedLicense: false,
      showXy:false,//是否显示隐私协议
      corpId:'',
      remember:false,//记住登录状态
      hasCompId:true//区分验证码登录时  总公司ID存在状态 默认存在
    }
  },
  created () {
    var params=parseQueryString()
    if(params&&params.loginType){
      standardSSO(params).then(res=>{
        this.$store.commit('SET_USERINFO', res.data)
      })
    }
  },

  mounted () {
    // update()//app 更新检查
    /**判断是否第一次启动
         * launchFlag 存在说明不是第一次启动
         * launchFlag 不存在 说明第一次启动
        */
    let launchFlag=localget('launchFlag')||''
    if(launchFlag){
      // 获取上一次登录的账号密码
      const AutoLogin_Params = localget('AutoLogin') || {}
      this.telphone = AutoLogin_Params.loginName
      if(!AutoLogin_Params.loginOut){
        this.password = AutoLogin_Params.password
        this.getImgValidCode()
      }
    }else if(isH5()){
      //如果是h5 显示隐私协议
      this.showXy=true
    }

    setTimeout(() => {
      if (this.canSubmit){
        this.checkedLicense=true
        this.getCorp()
      }
    }, 500)

    let lastRemember=localget('lastRemember')||{}
    if(lastRemember.corpId){
      this.loginConfig.compaySuper=lastRemember.compId
      this.corpId=lastRemember.corpId
      this.remember=true
    }
  },
  methods: {
    // 同意隐私协议
    agree(){
      this.showXy=false
      this.checkedLicense=true
      localset('launchFlag',new Date())
    },
    getCorpData(){
      let params = {
        'compId': this.loginConfig.compaySuper,
        'loginType': this.loginType,
        'loginName': this.telphone,
        'password': this.password,
        'validateCode': this.validCode,
        'validateCodeId': this.validateCodeId,
      }
      var self=this
      this.$store.dispatch('getCorpList', params).then(({item,msg}) => {
        if(Array.isArray(item)){
          if(item.length==0){
            self.$toast(msg)
            return
          }else if(item.length==1){
            var comp=item[0]
            if(comp.vipCorpList.length==1){
              self.corpChecked(comp.companyId,comp.vipCorpList[0].corpId,false)
            }else{
              self.compList=item
              self.$refs.corp.toggle()
            }
          }else{
            self.compList=item
            self.$refs.corp.toggle()
          }
        }else{
          self.$toast(msg)
        }
      })
    },
    // 选中企业
    corpChecked(compId,corpId,remember){
      if(compId){
        this.loginConfig.compaySuper=compId
      }
      this.corpId=corpId
      this.remember=remember
      if(this.remember){
        localset('lastRemember',{corpId:corpId,compId:this.loginConfig.compaySuper})
      }
      //关闭企业选择框
      if(this.loginType==1){
        this.login(this.corpId)
      }else if(this.loginType==2){
        if(this.hasCompId==false){
          this.getSmsValidCode()
        }else{
          this.login(this.corpId)
        }
      }
    },
    // 获取企业列表
    async getCorp () {
      console.log('000',this.checkedLicense)
      if(this.checkedLicense==false){
        this.$toast('请先阅读《隐私政策和服务协议》并选择同意')
        return
      }
      let valider = validators['is-string'](this.validCode, '校验码')
      if (this.loginType === 1 && this.failCount > this.failCountThreshold && !valider.valid) {
        this.$validErrorTips(valider.msg)
        return
      }
      if (!this.telphone || !this.password) return
      try {
        if(this.corpId&&this.loginConfig.compaySuper){
          this.login(this.corpId)
        }else{
          this.getCorpData()
        }
      } catch (err) {
        console.log(err)
        this.$responeFailTips(err.msg)
        /**
         * 用户名 密码登录情况下
         * 失败超过失败次数阈值 输入验证码
         */
        if (this.loginType === 1) {
          this.failCount = err.failCount || this.failCount
          if (this.failCount >= this.failCountThreshold) {
            this.getImgValidCode()
          }
        }
      }
    },
    // 登录
    async login (corpId) {
      if(this.remember){
        localset('lastRemember',{corpId:corpId,compId:this.loginConfig.compaySuper})
      }
      let deviceInfo=getDeviceInfo()
      let params = {
        loginType: this.loginType,
        loginName: this.telphone,
        password: this.password,
        compId: this.loginConfig.compaySuper,
        corpId,
        deviceId :deviceInfo.uuid||'',//(string, optional): 设备标识 ,
        deviceShortname :deviceInfo.companyVendor?(deviceInfo.companyVendor+'-'+deviceInfo.phoneModel):'',//(string, optional): 设备型号 ,
        autologinType :2,//(integer, optional): 登陆方式,1-自动登录2-手动登录
      }
      // alert('login页面 登录入参'+JSON.stringify(params))
      this.$store.dispatch('login', params)
    },
    // 获取短信验证码
    async getSmsValidCode () {
      if(this.smsCodeTips !== '获取验证码' && this.smsCodeTips !== '重新发送') return false

      let valider = validators['is-string'](this.telphone, '手机号码')
      if (!valider.valid) {
        this.$validErrorTips(valider.msg)
        return
      }
      if(this.loginConfig.compaySuper){
        this.getCode()
      }else{
        this.hasCompId=false
        this.getCorpData()
      }
    },
    //获取短信验证码
    getCode(){
      this.$api['user/smsCodeGet']({
        compId: this.loginConfig.compaySuper,
        phoneNumber: this.telphone,
        type: '登录'
      }).then(() => {
        // 倒计时 60s
        let threshold = 60,
          count = 0
        let time = setInterval(() => {
          let diff = threshold - count
          count ++
          this.smsCodeTips = `${diff} S`
          if(diff === 0) {
            clearInterval(time)
            this.smsCodeTips = '重新发送'
          }
        }, 1000)
      })
    },
    // 获取图片验证码
    async getImgValidCode () {
      this.validateCodeId = new Date().getTime()
      this.validCodeImgSrc = `${API_DEFAULT_CONFIG.URL.api}/obt/getValidateCode?validateCodeId=${this.validateCodeId}`
    },
    // 改变登录方式
    onClick(name) {
      this.loginType =name+1
      this.password = ''
    },
    changeValidCode() {
      if (this.validCode.length > 6) {
        this.validCode = this.validCode.slice(0, 6)
      }else {
        this.validCode = this.validCode
      }
    }
  },
  computed: {
    canSubmit: vm => !!(vm.telphone && vm.password),
    ...mapGetters(['loginConfig'])
  }
}
</script>

<style lang="less" scoped>
.Login {
    color: @color-text-black;
    background-color: @color-text-white;
    //padding: 0 30px;

    .login-input {
        //border-bottom: 1px solid @color-background-lightGray;

        .van-row--flex {
        align-items: baseline;
        }

        .van-field {
        //padding: 48px 0 12px;
          padding: 25px 0 12px;

        .van-field__control {
            font-size: 16px;
        }
        }
    }

    .title {
    }

    .logo img {
        width: 50px;
        border-radius: 50%;
    }

    .welcome {
        padding: 0 0 44px;
    }

    .login_btn {
      width: 302px;
      background-image: linear-gradient(to right, #764EE4 , #6F71ED);
      width:96%;
      color: #fff;
      font-size: 15px;
      margin: 0 0 0 -7px;
    }
    .valid-img {
        .valid-password {
        padding-right: 10px;
        }
    }
    .forget {
        margin-top: 40px;
    }

    .license {
        margin-top: 16px;
        font-size: 13.5px;
    }
    .showLicense {
        height: calc(100vh - 50px);
        padding: 10px;
        text-indent: 20px;
    }
    .box{
        padding: 20px;
    }
    .indent{
        text-indent: 20px;
    }
}
.showLicense2{
    height: calc(100vh - 50px);
    padding: 10px;
    text-indent: 20px;
}
.to1{
  position: absolute;
  left: 27px;
  top: 27px;
}
.to2{
  img{
    width: 100%;
    height: 260px;
    margin: 95px 0px 0 0;
  }
}
.kh-login{
  // width: 400px;
  box-sizing: border-box;
  position: absolute;
  padding: 0px 11px 0 37px;
  width: 100%;
}
/deep/ .van-tabs__line{
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 1;
  width: 94px;
  height: 2px;
  border-radius: 1.5px;
}
/deep/ .van-button--disabled {
  cursor: not-allowed;
  opacity: 6.5;
}

/deep/ .van-field__control{
  width: 95%;
  height: 45px;
  background: #EEEEF6;
  line-height: 20px;
  border-radius: 10px;
}
.khmain-color{
  color:#764EE4;
}

/deep/ .van-cell::after{
  border-bottom:none;
}
/deep/ .van-field__right-icon{
  position: relative;
  left: -38px;
}

/deep/ .text-right{
  text-align: right;
  position: absolute;
  left: 85%;
  bottom: 136px;
}
.kh-log{
  width:86px;
  height: 40px;
  font-size: 12px;
  position: relative;
  top: -5px;
}

.kh-phone-log{
  position: absolute;
  top: 80px;
  right: 50px;
  color: #999999;
  }
  .kh-phone-log2{
  font-size: 27px;
  position: absolute;
  top: 160px;
  right: 50px;
  }
.kh-log1{
  font-size: 27px;
  position: absolute;
  top: -10px;
  left: -15px;
}
/deep/ .van-icon-contact{
  font-size: 20px;
}
.kh-yzm{
  width: 100%;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}
/deep/ .van-field__control{
  padding-left: 10px;
}
.kh-back{
  position: absolute;
  top: 4px;
  left: 4px;
}
</style>
